import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import onClickOutside from 'react-onclickoutside'
import { connect } from 'react-redux'
import { compose, mapProps, withStateHandlers } from 'recompose'
import { updateBoard } from '../../../../../store/actions/boards'
import { updateFolder } from '../../../../../store/actions/folders'
import ColorButton from '../../../../common/ColorButton'
import EditName from './EditName'
import EditColor from './EditColor'
import GlobalNavRowEdit from './GlobalNavRowEdit'

export const enhance = compose(
  connect(null, (dispatch, props) => ({
    update: data => {
      if (props.item.type === 'board') {
        dispatch(updateBoard(props.item, data))
      } else {
        dispatch(updateFolder(props.item, data))
      }
    }
  })),
  withStateHandlers(
    { newName: null },
    { change: () => newName => ({ newName }) }
  ),
  mapProps(({ item, level, update, newName, change, editDone }) => ({
    item,
    level,
    change,
    name: newName !== null ? newName : item.name,
    saveName: () => {
      update({ name: newName || item.name })
    },
    saveAndExit: () => {
      update({ name: newName || item.name })
      editDone()
    },
    handleClickOutside: () => {
      update({ name: newName || item.name })
      editDone()
    },
    saveColor: color => update({ color }),
    cancel: editDone
  })),
  onClickOutside
)

export class GlobalNavRowEditContainer extends Component {
  select() {
    this.textInput.select()
  }
  componentDidMount() {
    this.select()
  }
  render() {
    const {
      item,
      level,
      saveColor,
      name,
      change,
      saveName,
      saveAndExit,
      cancel
    } = this.props
    return (
      <GlobalNavRowEdit level={level}>
        <ColorButton color={item.color} onChange={color => saveColor(color)}>
          {({ ref, toggle, showPicker }) => (
            <EditColor
              item={item}
              innerRef={ref}
              onClick={toggle}
              showPicker={showPicker}
            />
          )}
        </ColorButton>
        <EditName
          ref={ref => (this.textInput = findDOMNode(ref))}
          value={name}
          onChange={event => change(event.target.value)}
          onBlur={saveName}
          onFocus={() => this.select()}
          onKeyDown={event => {
            if (event.key === 'Enter') saveAndExit()
            if (event.key === 'Escape') cancel()
          }}
        />
      </GlobalNavRowEdit>
    )
  }
}

GlobalNavRowEditContainer.propTypes = {
  item: PropTypes.object.isRequired,
  level: PropTypes.number
}

export default enhance(GlobalNavRowEditContainer)
